import Vue from 'vue'
import Element from 'element-ui'
import Cookies from 'js-cookie'

// 视频播放组件
import vueMiniPlayer from 'vue-mini-player'
import 'vue-mini-player/lib/vue-mini-player.css'

//预览图片组件

import Viewer from 'v-viewer'
import '@/styles/viewer.css'

import App from './App.vue'
import router from './router'
import store from './store'

import './styles/element-variables.scss'
import '@/styles/index.scss' // global css
import '@/styles/ruoyi.scss' // ruoyi css,不增加他，有增加按钮点不动的现象

import './icons' // 引入icon，在src目录下
// import './assets/icons' //注册全局组件 svg-icon
import './permission' // permission control

import directive from './directive' //指令
import plugins from './plugins' // plugins

// 分页组件
import Pagination from "@/components/Pagination";
// 字典标签组件
import DictTag from '@/components/DictTag'
// 字典数据组件
import DictData from '@/components/DictData'
import RightToolbar from "@/components/RightToolbar"


Vue.use(Viewer);
Vue.use(vueMiniPlayer)

Vue.use(directive);
Vue.use(plugins);
// set element-ui default size
Vue.use(Element, {
  size: Cookies.get('size') || 'medium' 
})
// 全局组件挂载
Vue.component('DictTag', DictTag);
Vue.component('Pagination', Pagination);
Vue.component('RightToolbar', RightToolbar);

import { parseTime, resetForm, addDateRange, selectDictLabel, selectDictLabels, handleTree } from "@/utils/ruoyi";
// 全局方法挂载

Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels

Vue.prototype.handleTree = handleTree



DictData.install();
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
